import { render, staticRenderFns } from "./ConnectCampaign.vue?vue&type=template&id=20102213&"
import script from "./ConnectCampaign.vue?vue&type=script&lang=js&"
export * from "./ConnectCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports